import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";

export const Route = createFileRoute("/_app/stock/inventaires")({
  staticData: {
    title: "Inventaires",
    icon: ClipboardList,
    tab_icon: ClipboardList,
    permission: PERMISSIONS.STOCK.INVENTAIRES.VIEW,
    module: "stock",
    section: "Stock",
    order: 49,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission(PERMISSIONS.STOCK.INVENTAIRES.VIEW),
  component: () => <Outlet />,
});
